var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgHomeIcon = function SvgHomeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.565 2.484a2.772 2.772 0 00-3.13 0L3.256 7.37A2.897 2.897 0 002 9.768v9.352C2 20.71 3.263 22 4.82 22h4.103c.425 0 .77-.352.77-.785v-5.237c0-.723.573-1.31 1.281-1.31h2.052c.708 0 1.282.587 1.282 1.31v5.237c0 .433.344.785.769.785h4.103c1.557 0 2.82-1.29 2.82-2.88V9.768c0-.963-.471-1.863-1.256-2.397l-7.18-4.887z",
    fill: "url(#Home_icon_svg__clrjgxgp5a)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "Home_icon_svg__clrjgxgp5a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(7.00248 15.5529 -16.1767 7.28333 4.997 6.447)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0076FF"
  })))));
};
export default SvgHomeIcon;